module.exports = __webpack_public_path__ + "img/home-play-icon.9fea6d25.svg";